// extracted by mini-css-extract-plugin
module.exports = {"logoLarge":"Logo_logoLarge__15Usw","content":"Logo_content__zUs0p","logoSmall":"Logo_logoSmall__j-Kt_"};